export default __webpack_public_path__ + "static/TheDreamlurker-3b5cdd989de19daf36372eb570909cd4.png";